module.exports = __webpack_public_path__ + "static/favicon-c51e279b40744ac5219bd0668aa072e7.ico";